import { useState } from 'react'
import { sendSupportRequest } from '../api'

interface SupportFloatProps {
  enrolleeId?: string
}

export default function SupportFloat({ enrolleeId }: SupportFloatProps) {
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [busy, setBusy] = useState(false)
  const [sent, setSent] = useState(false)
  const [err, setErr] = useState('')

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!message.trim()) return
    setBusy(true)
    setErr('')
    try {
      await sendSupportRequest(message.trim(), enrolleeId)
      setSent(true)
      setMessage('')
    } catch (ex: unknown) {
      setErr(ex instanceof Error ? ex.message : 'Could not send message.')
    } finally {
      setBusy(false)
    }
  }

  function handleClose() {
    setOpen(false)
    setSent(false)
    setErr('')
    setMessage('')
  }

  return (
    <>
      <button
        className="p-support-btn"
        onClick={() => setOpen(o => !o)}
        aria-label="Get support"
      >
        ?
      </button>

      {open && (
        <div className="p-support-drawer">
          <div className="p-support-header">
            <span>Need help?</span>
            <button className="p-support-close" onClick={handleClose}>×</button>
          </div>

          {sent ? (
            <div className="p-support-sent">
              <div style={{ fontSize: 28, marginBottom: 8 }}>✓</div>
              <p>Message sent. We'll be in touch soon.</p>
              <button
                className="p-btn p-btn-outline p-btn-sm"
                style={{ marginTop: 12 }}
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="p-support-form">
              <p style={{ fontSize: 13, color: 'var(--muted)', marginBottom: 12 }}>
                Send us a message and we'll follow up by email.
              </p>
              {err && <div className="p-error" style={{ marginBottom: 10 }}>{err}</div>}
              <textarea
                placeholder="What can we help you with?"
                value={message}
                onChange={e => setMessage(e.target.value)}
                rows={4}
                disabled={busy}
                required
              />
              <button
                type="submit"
                className="p-btn p-btn-primary p-btn-full"
                disabled={busy || !message.trim()}
                style={{ marginTop: 8 }}
              >
                {busy ? 'Sending…' : 'Send message'}
              </button>
            </form>
          )}
        </div>
      )}
    </>
  )
}
